export default function Products() {
  const products = [
    {
      name: 'Herbal Powder for Hair',
      description: 'Natural herbal blend powder specially formulated for nourishing and strengthening hair',
      image: 'https://static.readdy.ai/image/57610a2a25a44577dbc5593c17f23216/281b66888b09e4eb38fecf9d02145d6c.jpeg'
    },
    {
      name: 'Indigo Powder',
      description: 'Pure natural indigo powder for deep dark hair coloring and conditioning',
      image: 'https://static.readdy.ai/image/57610a2a25a44577dbc5593c17f23216/c1c90fb1cfc34526d53aac4b48e44942.jpeg'
    },
    {
      name: 'All Type Herbs Raw or Powder Form',
      description: 'Wide range of natural herbs available in both raw and finely ground powder form',
      image: 'https://static.readdy.ai/image/57610a2a25a44577dbc5593c17f23216/9c4f7f71d18a3d8a3ca5c27e958bdce5.jpeg'
    },
    {
      name: 'Black Henna Powder',
      description: '100% natural black henna powder for rich, dark mehndi designs and hair coloring',
      image: 'https://static.readdy.ai/image/57610a2a25a44577dbc5593c17f23216/86af06b8b76c1e10ea5bdabaf9d6aae0.jpeg'
    },
    {
      name: 'Burgundy Henna Powder',
      description: 'Premium burgundy henna powder for vibrant reddish-brown hair color and mehndi art',
      image: 'https://static.readdy.ai/image/57610a2a25a44577dbc5593c17f23216/42c196d4fba2c7648450ad8cda7677cd.jpeg'
    },
    {
      name: 'Private Label & Customized Packaging',
      description: 'We provide export-quality henna powder with complete private label and customized packaging solutions for global brands.',
      image: 'https://static.readdy.ai/image/57610a2a25a44577dbc5593c17f23216/291162d16774021e7dcb161046eebed3.png'
    }
  ];

  return (
    <section id="products" className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Our Products
          </h2>
          <div className="w-24 h-1 bg-orange-500 mx-auto mb-6"></div>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
            Premium quality henna powder products for various applications
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product, index) => (
            <div
              key={index}
              className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2 group"
            >
              <div className="w-full h-72 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">{product.name}</h3>
                <p className="text-sm text-gray-600 mb-4">{product.description}</p>
                <button
                  onClick={() => {
                    const element = document.getElementById('contact');
                    if (element) {
                      const offset = 80;
                      const elementPosition = element.getBoundingClientRect().top;
                      const offsetPosition = elementPosition + window.pageYOffset - offset;
                      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
                    }
                  }}
                  className="text-orange-500 font-semibold hover:text-orange-600 transition-colors flex items-center space-x-2 cursor-pointer whitespace-nowrap"
                >
                  <span>Get Quote</span>
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}